import React from "react";

const Textarea = ({ ...props }) => {
  const {
    name,
    id,
    className,
    value,
    maxLength,
    placeholder,
    required,
    onChange,
    readOnly,
    disabled,
    hasError = false,
    rows,
    cols,
  } = props;
  const readOnlyClass = "read-only:bg-gray-200 read-only:cursor-not-allowed";
  const disabledClass = "disabled:bg-gray-200 disabled:cursor-not-allowed";
  const borderClass =hasError === false ? "border-tenken-gray-500" : "border-red-500";
  const focusClass = "focus:bg-yellow-100 focus:ring-transparent focus:border-gray-500";
  const inputClass = `${readOnlyClass} ${disabledClass} ${focusClass} placeholder:text-gray-400 bg-white border ${borderClass} rounded-[8px] py-[8px] px-2 ${className || ""}`;
  return (
    <textarea
      className={inputClass}
      name={name}
      id={id ? id : null}
      rows={rows ? rows : null}
      cols={cols ? cols : null}
      maxLength={maxLength ? maxLength : null}
      placeholder={placeholder ? placeholder : null}
      value={value !== undefined ? value : null}
      onChange={onChange ? onChange : null}
      required={required !== undefined ? required : false}
      readOnly={readOnly !== undefined ? readOnly : null}
      disabled={disabled !== undefined ? disabled : null}
    />
  );
};

export default Textarea;
